// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__C9xMx","form-title":"Common_form-title__2jnD8","form-actions":"Common_form-actions__XtekT"};